import {inject, Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {FileDownloadService} from './file-download.service';
import * as FileDownloadActions from './file-download.actions';
import {catchError, map, switchMap, tap} from 'rxjs/operators';
import {of} from 'rxjs';

@Injectable()
export class FileDownloadEffects {
  private readonly fileDownloadService: FileDownloadService = inject(FileDownloadService);
  private readonly actions$: Actions = inject(Actions);

  downloadCSV$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FileDownloadActions.downloadCSV),
      switchMap(({projectId, filter}) =>
        this.fileDownloadService.downloadCSV(projectId, filter).pipe(
          tap(blob => this.fileDownloadService.saveFile(blob, 'researchpapers.csv')),
          map(() => FileDownloadActions.downloadCSVSuccess()),
          catchError(error => of(FileDownloadActions.downloadCSVFailure({error})))
        )
      )
    )
  );

  downloadBibtex$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FileDownloadActions.downloadBibtex),
      switchMap(({projectId, filter}) =>
        this.fileDownloadService.downloadBibtex(projectId, filter).pipe(
          tap(blob => this.fileDownloadService.saveFile(blob, 'researchpaper.bib')),
          map(() => FileDownloadActions.downloadBibtexSuccess()),
          catchError(error => of(FileDownloadActions.downloadBibtexFailure({error})))
        )
      )
    )
  );
}
